/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import {
  IHolidaysFetcherParams,
  IHolidaysFetcherRes,
  IHolidaysRegionCountriesFetcherParams,
  IHolidaysRegionCountriesFetcherRes,
} from '@/pages/home/types/holidays';

/**
 * 获取指定时间段、指定国家范围的 节假日列表数据
 * @param params 获取节假日列表数据入参对象
 * @returns 节假日列表数据
 */
export const fetchHolidays = (
  params: IHolidaysFetcherParams,
): Promise<IHolidaysFetcherRes> => {
  return http({
    url: '/api/v1/homepage/pc/holiday',
    method: 'post',
    data: params,
  }) as Promise<IHolidaysFetcherRes>;
};

/**
 * 获取指定时间范围内的节假日模块的国家地区列表数据
 * @param params 获取节假日模块的国家地区列表数据入参对象
 * @returns 节假日模块的国家地区列表数据
 */
export const fetchHolidaysRegionCountries = (
  params: IHolidaysRegionCountriesFetcherParams,
): Promise<IHolidaysRegionCountriesFetcherRes> => {
  return http({
    url: '/api/v1/homepage/pc/filterHolidayRegionCountry',
    method: 'post',
    data: params,
  }) as Promise<IHolidaysRegionCountriesFetcherRes>;
};
